import { NAME as sitemapName } from './constants';
import sitemapReducer from './reducer';

export {
  sitemapName,
  sitemapReducer,
};



// WEBPACK FOOTER //
// ./modules/Sitemap/redux/index.js